export default __webpack_public_path__ + "static/media/1773.62ff8e83.png";